import React from 'react';
import authRoles from '../../../auth/authRoles';
import AdminDashboard from './AdminDashboard';

const AdminDashboardConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/company',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AdminDashboard />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.admin,
};

export default AdminDashboardConfig;
